import { navigate } from 'gatsby';
import Img from 'gatsby-image';
import propTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import styles from './productcard.module.css';

import BagIcon, { BagIconFilled } from '../../assets/svg/BagIcon';
import { useBag } from '../../context/BagContext';
import { useBagController } from '../../context/BagDisplayContext';
import { currencyMask } from '../../services/maskService';

const ProductCard = ({ product }) => {
  const { id, name, price, image, slug } = product;
  const { addProduct, removeProduct, checkProduct, bag } = useBag();
  const { showBag } = useBagController();
  const [isAdded, setAdded] = useState(checkProduct(id));

  const toggleBag = () => {
    if (isAdded) {
      removeProduct(id);
      setAdded(false);
    } else {
      addProduct({ ...product, quantity: 1 });
      setAdded(true);
      showBag();
    }
  };

  let isDragging = false;

  const goto = (slug) => {
    if (isDragging) {
      isDragging = false;
      return;
    }
    return navigate(slug);
  };

  useEffect(() => {
    setAdded(checkProduct(id));
  }, [bag, id, checkProduct]);

  const handleOnDragStart = (e) => {
    e.preventDefault();
    isDragging = true;
  };

  return (
    <div className={"px-1 md:px-2"}>
      <div onClick={() => goto(`/products${slug}`)} onDragStart={handleOnDragStart} className="cursor-pointer">
        {image.childImageSharp ? (
          <Img fluid={image.childImageSharp.fluid} alt={name} className={`rounded-md bg-white ${styles.customBorder}`} />
        ) : (
          <div className="relative pb-4/3">
            <img className="absolute w-full h-full object-cover" src={image} alt={name} />
          </div>
        )}
      </div>
      <div className="flex flex-row justify-between items-start mt-4">
        <div>
          <div onClick={() => goto(`/products${slug}`)} onDragStart={handleOnDragStart} className="text-md text-black font-bold overflow-hidden cursor-pointer">{name}</div>
          <p className="text-sm text-gray-700">{currencyMask(price)}</p>
        </div>
        <button
          aria-label={isAdded ? 'Remove from bag' : 'Add to bag'}
          onClick={toggleBag}
          type="button"
          className="cursor-pointer text-black h-5 w-5 ml-3"
        >
          {isAdded ? <BagIconFilled /> : <BagIcon />}
        </button>
      </div>
    </div>
  );
};

ProductCard.propTypes = {
  product: propTypes.shape({
    id: propTypes.string.isRequired,
    name: propTypes.string.isRequired,
    price: propTypes.number.isRequired,
    image: propTypes.oneOfType([propTypes.shape(), propTypes.string]).isRequired,
    seller: propTypes.shape.isRequired,
    slug: propTypes.string.isRequired,
  }).isRequired,
};

export default ProductCard;
